(() => {
 const headerScroller = document.querySelector('.page-wrapper');
 let headerScrollY = Math.max(0, headerScroller?.scrollTop || window.scrollY), headerFrame = false;
 document.addEventListener('scroll', event => {
  if (event.target !== document && event.target !== headerScroller) return;
  const scroller = event.target === document ? document.documentElement : headerScroller;
  if (headerFrame) return;
  headerFrame = true;
  requestAnimationFrame(() => {
   headerFrame = false;
   const header = document.querySelector('.ed-header');
   const y = Math.max(0, Math.min(scroller.scrollTop, scroller.scrollHeight - scroller.clientHeight));
   if (!header) return;
   if (y <= header.offsetHeight) {
    header.classList.remove('is-scroll-hidden');
    headerScrollY = y;
   } else if (Math.abs(y - headerScrollY) >= 6) {
    header.classList.toggle('is-scroll-hidden', y > headerScrollY);
    headerScrollY = y;
   }
  });
 }, { passive: true, capture: true });
 document.addEventListener('focusin', event => {
  const header = event.target.closest('.ed-header');
  if (header) header.classList.remove('is-scroll-hidden');
 });
 const initialize = () => {
  document.querySelectorAll('[data-hero-slideshow]').forEach(hero => {
   if (hero.dataset.ready) return;
   hero.dataset.ready = 'true';
   const slides = [...hero.querySelectorAll('.ed-hero__slide')];
   const pause = hero.querySelector('[data-hero-pause]');
   const reduced = matchMedia('(prefers-reduced-motion: reduce)');
   let index = 0, paused = reduced.matches, timer;
   const show = n => {
    index = (n + slides.length) % slides.length;
    slides.forEach((slide,i) => {slide.classList.toggle('is-active', i === index); slide.setAttribute('aria-hidden',String(i !== index));});
    hero.querySelector('[data-hero-count]').textContent = `${index + 1} / ${slides.length}`;
   };
   const schedule = () => {
    clearInterval(timer);
    if (!paused && slides.length > 1) timer = setInterval(() => {if (!hero.isConnected) clearInterval(timer); else if (!document.hidden && hero.getBoundingClientRect().bottom > 0) show(index + 1);}, 6000);
    pause.textContent = paused ? '▷' : 'Ⅱ';
    pause.setAttribute('aria-label', paused ? pause.dataset.play : pause.dataset.pause);
   };
   hero.querySelector('[data-hero-prev]').addEventListener('click',()=>{show(index-1);schedule();});
   hero.querySelector('[data-hero-next]').addEventListener('click',()=>{show(index+1);schedule();});
   pause.addEventListener('click',()=>{paused=!paused;schedule();});
   reduced.addEventListener('change',()=>{paused=reduced.matches;schedule();});
   schedule();
  });
  document.querySelectorAll('[data-look-gallery]').forEach(gallery => {
   if (gallery.dataset.ready) return;
   gallery.dataset.ready = 'true';
   const dialog = gallery.querySelector('dialog');
   const track = dialog.querySelector('.ed-lightbox__track');
   const slides = [...track.children];
   let index = 0, opener, priorOverflow;
   const sync = () => {index=Math.round(track.scrollLeft/(track.clientWidth||1)); const count=dialog.querySelector('[data-look-count]'); if(count.textContent!==String(index+1)) count.textContent=String(index+1);};
   const show = (n,smooth=true) => {index=(n+slides.length)%slides.length;track.scrollTo({left:index*track.clientWidth,behavior:smooth&&!matchMedia('(prefers-reduced-motion: reduce)').matches?'smooth':'instant'});};
   gallery.querySelectorAll('[data-look-open]').forEach(button=>button.addEventListener('click',()=>{opener=button;priorOverflow=document.documentElement.style.overflow;dialog.showModal();document.documentElement.style.overflow='hidden';show(Number(button.dataset.lookOpen),false);sync();}));
   dialog.querySelector('[data-look-close]').addEventListener('click',()=>dialog.close());
   dialog.addEventListener('close',()=>{document.documentElement.style.overflow=priorOverflow;opener?.focus({preventScroll:true});});
   dialog.querySelectorAll('[data-look-step]').forEach(button=>button.addEventListener('click',()=>show(index+Number(button.dataset.lookStep))));
   track.addEventListener('scroll',sync,{passive:true});
   dialog.addEventListener('keydown',event=>{if(event.key==='ArrowRight'||event.key==='ArrowLeft'){event.preventDefault();show(index+(event.key==='ArrowRight'?1:-1));}});
  });
  document.querySelectorAll('[data-card-gallery]').forEach(gallery => {
   if (gallery.dataset.ready) return;
   gallery.dataset.ready = 'true';
   const track = gallery.querySelector('.ed-card__slides');
   const slides = [...track.children];
   const count = gallery.querySelector('[data-slide-current]');
   let index = 0;
   const sync = () => {
    index = Math.max(0, Math.min(slides.length - 1, Math.round(track.scrollLeft / (track.clientWidth || 1))));
    if (count && count.textContent !== String(index + 1)) count.textContent = String(index + 1);
    slides.forEach((slide,i) => { slide.tabIndex = i === index ? 0 : -1; });
   };
   const move = step => {
    const next = (index + step + slides.length) % slides.length;
    track.scrollTo({left: next * track.clientWidth, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
   };
   gallery.querySelectorAll('[data-slide-step]').forEach(button => button.addEventListener('click', () => move(Number(button.dataset.slideStep))));
   track.addEventListener('scroll', sync, {passive:true});
   let interactionTimer;
   gallery.addEventListener('pointerdown',()=>{gallery.classList.add('is-interacting');clearTimeout(interactionTimer);interactionTimer=setTimeout(()=>gallery.classList.remove('is-interacting'),1800);},{passive:true});
   track.addEventListener('keydown', event => {
    if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') { event.preventDefault(); move(event.key === 'ArrowRight' ? 1 : -1); }
   });
   sync();
  });
  document.querySelectorAll('[data-size-guide]').forEach(guide => {
   if (guide.dataset.ready) return;
   guide.dataset.ready = 'true';
   const cells = [...guide.querySelectorAll('tbody td')];
   cells.forEach(cell => cell.dataset.cm = cell.textContent.trim());
   const refresh = () => {
    const section = guide.closest('.shopify-section') || document;
    const checked = [...section.querySelectorAll('input[type="radio"]:checked')].map(input => input.value);
    const headers = [...guide.querySelectorAll('thead th')].slice(1).map(el => el.textContent.trim());
    let selected;
    guide.querySelectorAll('tbody tr').forEach(row => {
     const match = checked.includes(row.querySelector('th')?.textContent.trim());
     row.classList.toggle('is-selected', match);
     if (match) selected = row;
    });
    const unit = guide.querySelector('[data-unit][aria-pressed="true"]')?.dataset.unit || 'cm';
    if (selected) guide.querySelector('[data-selected-size]').textContent = '選択サイズ ' + selected.querySelector('th').textContent.trim() + ' / ' + [...selected.querySelectorAll('td')].map((c,i) => headers[i] + ' ' + c.textContent).join('・') + ' ' + unit;
   };
   guide.querySelectorAll('[data-unit]').forEach(button => button.addEventListener('click', () => {
    guide.querySelectorAll('[data-unit]').forEach(b => b.setAttribute('aria-pressed', String(b === button)));
    cells.forEach(cell => { const n = Number(cell.dataset.cm); cell.textContent = button.dataset.unit === 'cm' ? cell.dataset.cm : (n / 2.54).toFixed(1); });
    refresh();
   }));
   (guide.closest('.shopify-section') || document).addEventListener('change', refresh);
   refresh();
  });
 };
 initialize();
 let scheduled;
 new MutationObserver(() => { clearTimeout(scheduled); scheduled = setTimeout(initialize, 60); }).observe(document.getElementById('MainContent') || document.body, { childList: true, subtree: true });
 document.addEventListener('shopify:section:load', initialize);
})();
